import { cx } from "../../utils/classNames";
import ui from "./ui.module.css";

// tabs: [{ id, label, count? }]
// variant "underline" for page-level tabs, "pills" for sub-tabs.
const Tabs = ({ tabs, active, onChange, variant = "underline" }) => {
  const isPills = variant === "pills";

  return (
    <div className={isPills ? ui.pills : ui.tabs} role="tablist">
      {tabs.map((tab) => {
        const isActive = tab.id === active;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={
              isPills
                ? cx(ui.pill, isActive && ui.pillActive)
                : cx(ui.tab, isActive && ui.tabActive)
            }
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
            {tab.count > 0 && <span className={ui.tabCount}>{tab.count}</span>}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
